export interface Review {
  name: string;
  username: string;
  avatarBg: string;
  avatarText: string;
  text: string;
}

export const reviews: Review[] = [
  {
    name: "Marcus Chen",
    username: "@marcusfinds",
    avatarBg: "bg-accent-100",
    avatarText: "MC",
    text: "I have been using the Kakobuy spreadsheet for over six months now, and it has completely transformed how I source sneakers. The seller vetting is top-notch \u2014 every pair I have ordered matched the description perfectly. Saved me from at least three potential scams already.",
  },
  {
    name: "Elena Rodriguez",
    username: "@elenastyle",
    avatarBg: "bg-primary-100",
    avatarText: "ER",
    text: "As someone new to Kakobuy, this spreadsheet was a lifesaver. The comparison tables helped me find the best hoodie sellers instantly, and the shipping guide made the whole process stress-free. Cannot recommend it enough for beginners!",
  },
  {
    name: "James Park",
    username: "@jparkkicks",
    avatarBg: "bg-secondary-100",
    avatarText: "JP",
    text: "The weekly updates are what sets this spreadsheet apart. I have discovered so many trending pieces before they blew up on social media. The seller ratings are incredibly accurate \u2014 I have never been disappointed following their recommendations.",
  },
  {
    name: "Sophie Williams",
    username: "@sophiewbuy",
    avatarBg: "bg-accent-100",
    avatarText: "SW",
    text: "Honestly the best resource for Kakobuy shopping. The budget finds section alone has saved me hundreds of dollars. Every category is well-organized, and the direct links make browsing so much faster than navigating the app manually.",
  },
  {
    name: "David Thompson",
    username: "@davethomps",
    avatarBg: "bg-primary-100",
    avatarText: "DT",
    text: "I was skeptical about using spreadsheets for shopping, but this changed my mind completely. The quality check guide helped me inspect my first order properly, and the community feedback loop means the data keeps getting better. A must-have for serious buyers.",
  },
  {
    name: "Amara Okafor",
    username: "@amara_finds",
    avatarBg: "bg-secondary-100",
    avatarText: "AO",
    text: "What I love most is the safety section. Before finding this spreadsheet, I wasted money on two counterfeit jackets. Now I know exactly which sellers to trust and how to verify products before ordering. The peace of mind alone is worth it.",
  },
];

export const comparisonData = [
  { seller: "TopSneakerHub", quality: 9.4, price: "$$$", shipping: "5-8 days", rating: 5, verified: true, specialty: "Premium Sneakers" },
  { seller: "StreetWearDirect", quality: 9.1, price: "$$", shipping: "6-10 days", rating: 5, verified: true, specialty: "Hoodies & Tees" },
  { seller: "BudgetFinds99", quality: 8.5, price: "$", shipping: "7-12 days", rating: 4, verified: true, specialty: "Budget Picks" },
  { seller: "LuxuryConnect", quality: 9.6, price: "$$$$", shipping: "4-7 days", rating: 5, verified: true, specialty: "Designer Items" },
  { seller: "QuickShipStore", quality: 8.8, price: "$$", shipping: "3-6 days", rating: 4, verified: true, specialty: "Fast Shipping" },
];